import { render, staticRenderFns } from "./MarqetaCardReplacement.vue?vue&type=template&id=6dd269e4&scoped=true"
import script from "./MarqetaCardReplacement.vue?vue&type=script&lang=js"
export * from "./MarqetaCardReplacement.vue?vue&type=script&lang=js"
import style0 from "./MarqetaCardReplacement.vue?vue&type=style&index=0&id=6dd269e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd269e4",
  null
  
)

export default component.exports